import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { adminLogout } from '../../utils/auth';
import { PortalAccessProvider } from '../../components/PortalAccess';
import PortalNavigation from '../../components/PortalNavigation';

function initTheme() {
  const saved = localStorage.getItem('theme') || 'dark';
  document.documentElement.setAttribute('data-theme', saved);
  return saved;
}

export default function AdminLayout() {
  return <PortalAccessProvider><AdminShell /></PortalAccessProvider>;
}

function AdminShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [theme, setTheme] = useState(initTheme);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const onKeyDown = event => {
      if (event.key === 'Escape') setMobileMenuOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [mobileMenuOpen]);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    document.documentElement.setAttribute('data-theme', next);
    localStorage.setItem('theme', next);
  };

  const handleLogout = () => {
    adminLogout();
    navigate('/admin/login');
  };

  const closeMenuAfterNavigation = event => {
    if (event.target.closest('a')) setMobileMenuOpen(false);
  };

  return (
    <div className="admin-layout">
      <header className="mobile-admin-header">
        <button
          type="button"
          className="mobile-admin-menu-button"
          onClick={() => setMobileMenuOpen(true)}
          aria-label="Открыть меню портала"
          aria-expanded={mobileMenuOpen}
          aria-controls="admin-sidebar"
        >
          ☰ <span>Меню</span>
        </button>
        <span className="mobile-admin-title">🏢 Портал</span>
      </header>
      <button
        type="button"
        className={`sidebar-backdrop${mobileMenuOpen ? ' visible' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
        aria-label="Закрыть меню"
        tabIndex={mobileMenuOpen ? 0 : -1}
      />
      <aside id="admin-sidebar" className={`sidebar${mobileMenuOpen ? ' sidebar-mobile-open' : ''}`}>
        <div className="sidebar-logo">
          <span className="sidebar-logo-icon">🏢</span>
          <span className="sidebar-logo-text">Портал</span>
        </div>

        <PortalNavigation onNavigate={closeMenuAfterNavigation} />

        <div className="sidebar-footer">
          <button className="btn-theme-toggle" onClick={toggleTheme}>
            {theme === 'dark' ? '☀️ Светлая тема' : '🌙 Тёмная тема'}
          </button>
          <button className="btn-logout" onClick={handleLogout}>Выйти</button>
        </div>
      </aside>

      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
